<div class="mt-5 report__page__with__extra__scroll">
    <form #overviewForm="ngForm" novalidate="novalidate" autocomplete="off">

        <ng-container *ngIf="currentReport && currentReport.LATEST">

            <!-- #region "seller-business" -->
            <div class="row my-5">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">
                            Business Entity Name
                            <!-- <img class="ml-2 cursor-pointer" [popover]="getQbTooltip()" triggers="mouseenter:mouseleave" placement="top left" alt="..." *ngIf="currentReport.isQb" src="../../../../../assets/images/qb-green-icon.png" width="25"> -->
                        </div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        This is the legal name registered with the secretary of state where the Company was formed. You
                        can typically find this information on the Company’s federal tax returns, articles of incorporation,
                        and other similar documents.
                        and other similar documents.
                    </div>
                    <div *ngIf="currentReport?.LATEST?.COMPANY">
                        <input restrictFirstSpace type="text" class="input input__blue input__large"
                            #companyName="ngModel" name="companyName" id="companyName"
                            placeholder="e.g. Internal Evaluation, LLC" [(ngModel)]="currentReport.LATEST.COMPANY.NAME"
                            maxlength="150" tabindex="1" (ngModelChange)="checkNameForSame()"
                            (blur)="callUpdateAPI('COMPANY', 'NAME')" (keyup.enter)="callUpdateAPI('COMPANY', 'NAME')"
                            required [disabled]="currentReport?.isLocked">
                    </div>
                </div>

            </div>
            <!-- #endregion -->

            <!-- #region "company-dba" -->
            <div class="row my-5 company__dba" *ngIf="currentReport?.LATEST?.COMPANY?.NAME">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Company 'DBA' Name</div>
                        <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        ‘DBA’ stands for Doing Business As. This is the trade name of the Company (i.e. Dunkin Donuts of
                        XYZ, or Widgets America).
                    </div>
                    <div class="wrapper w-100"
                        *ngIf="currentReport && currentReport.LATEST && currentReport.LATEST.COMPANY">

                        <input type="text" restrictFirstSpace class="input input__large input__blue"
                            [(ngModel)]="currentReport.LATEST.COMPANY.DBA" maxlength="150" tabindex="2" #DBA="ngModel"
                            [disabled]="currentReport?.isLocked" name="DBA" id="DBA" placeholder="Doing Business as..."
                            (ngModelChange)="checkNameForSame()" (blur)="callUpdateAPI('COMPANY', 'DBA')"
                            (keyup.enter)="callUpdateAPI('COMPANY', 'DBA')">

                        <div class="checkbox__wrapped business__entity_mobile">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' name="isSameAsBusinessName"
                                    id="isSameAsBusinessName" [value]="true" [(ngModel)]="isSameAsBusinessName"
                                    [disabled]="currentReport?.isLocked" (ngModelChange)="changeValues()"
                                    tabindex="3" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator"></div>
                                    <p class="checkbox__text">Same as Business Entity Name</p>
                                </div>
                            </label>
                        </div>

                    </div>

                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "entity-reference" -->
            <div class="row my-5 align-items-center" *ngIf="false">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Borrower's Entity, Name or Reference</div>
                        <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        The company being appraised (Company) is the entity being sold (or refinanced).<br />
                        Therefore, all remaining information should be based on the Seller's financials or related to
                        the
                        Seller.
                        The actual Buyer should not have any bearing on the Fair Market Value of a business, which
                        should be based on a hypothetical Buyer.
                    </div>
                    <input restrictFirstSpace type="text" class="input input__large input__blue"
                        [(ngModel)]="currentReport.LATEST.BORROWER_NAME" placeholder="Company name" name="BORROWER_NAME"
                        id="BORROWER_NAME" #BORROWER_NAME="ngModel" tabindex="4" [disabled]="currentReport?.isLocked"
                        (blur)="callUpdateAPI('REPORT_VERSION', 'BORROWER_NAME')"
                        (keyup.enter)="callUpdateAPI('REPORT_VERSION', 'BORROWER_NAME')" maxlength="150">
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "industry-name" -->
            <div class="row my-5 industry__name" *ngIf="currentReport?.LATEST?.COMPANY?.NAME">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Industry Name or Code</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        Enter and search by typing in the NAICS code or NAICS description that most closely identifies
                        the
                        company
                    </div>
                    <div *ngIf="currentReport?.LATEST?.COMPANY">
                        <div class="search-field" #selectorNAICS>

                            <app-custom-search-input #naicsCode="ngModel" name="naicsCode" required delay="500"
                                placeholder="Start typing name or code" (outValue)="autocompleteNaics($event)"
                                [(ngModel)]="currentReport.LATEST.COMPANY.NAICS_NAME" (focusLost)="naicsFocusLost()"
                                [readonly]="currentReport.LATEST.COMPANY.NAICS" (keydown.tab)="naicsTabPress($event)"
                                (keydown.arrowup)="naicsArrowUp($event)" (keydown.arrowdown)="naicsArrowDown($event)"
                                (keydown.enter)="pickNaicsFromList($event)" [tabindex]="5"
                                (focusGained)="naicsAutoOpen = true" [disabled]="currentReport?.isLocked"
                                [hasResults]="naicsList?.length > 0 && naicsAutoOpen ? true : false">
                            </app-custom-search-input>

                            <a class="lock-icon" id="overview-reset-company-naics"
                                *ngIf="currentReport.LATEST.COMPANY.NAICS" tabindex="5" (keydown.enter)="resetNaics()"
                                (click)="currentReport.isLocked ? '' : resetNaics()">
                                <em class="fa fa-times" aria-hidden="true"></em>
                            </a>

                            <div id="NAICS_AUTOCOMPLETE" class="autocomplete custom__scroll input__search"
                                *ngIf="naicsList?.length > 0 && naicsAutoOpen">
                                <div class="item flex over" *ngFor="let naics of naicsList"
                                    (click)="selectNaics(naics)" [id]="'NAICS_' + naics.CODE"
                                    [ngClass]="{'disabled':!naics.CAN_VALUE, 'over': naics.isOver}">

                                    <div class="text"
                                         [popover]="!naics.CAN_VALUE ? 'Valzy is unable to determine the value of this industry type at this time. This may be because the industry type may be a Special Purpose Property which requires a real estate appraisal (not a business valuation) or the industry type may be ineligible for SBA purposes, and therefore Valzy may not have enough comparable transactional and industry data.' : ''"
                                         triggers="mouseenter:mouseleave" [placement]="'right'" [adaptivePosition]="true" container="body">
                                      {{naics.CODE + ' - ' + naics.NAICS_DESC}}
                                      <svg-icon name="filled-warning" svgClass="ml-1" *ngIf="!naics.CAN_VALUE"></svg-icon>
                                    </div>
                                </div>
                            </div>

                            <input type="text" [(ngModel)]="currentReport.LATEST.COMPANY.NAICS" #NAICS="ngModel"
                                style="display: none;" id="overview-industry-valuated" name="NAICS" required>
                            <small
                                *ngIf="!currentReport.LATEST.COMPANY.NAICS && (naicsCode.touched || overviewForm.submitted) || naicsError"
                                class="text-danger">Selection required</small>
                            <small *ngIf="naicsCanError" class="text-danger">
                                Valzy is unable to determine the value of this industry type at this time.
                                This may be because the industry type may be a Special Purpose Property which requires a real estate appraisal (not a business valuation) or the industry type may be ineligible for SBA purposes, and therefore Valzy may not have enough comparable transactional and industry data.
                            </small>
                        </div>
                    </div>

                </div>

                <div class="col-md-12 mt-3">
                    <div class="color-secondary-gray font-size-14">
                        If you need further assistance identifying the Company’s industry code, please visit
                        <a href="https://www.naics.com/search/" target="_blank" rel="noopener">www.naics.com</a>.
                        Generally, this information can be found on the Company's Federal Tax Returns.
                    </div>
                    <div class="color-secondary-gray font-size-14 py-3" *ngIf="!isEllipsis">
                        On the NAICS website, you can search for more descriptive or partial text. For example, if you
                        were
                        looking
                        for the industry code for a pharmacy, you could search for "pharmacies", "pharmacy", or "pharm"
                        and
                        each
                        would provide different results. When accessing a specific industry code, be careful to look at
                        both
                        the
                        generalized description as well as the corresponding index entries which will appear in a table
                        on
                        that
                        page. These two areas will help the most in deciding whether or not this industry code is a
                        best-fit
                        for the
                        Company.
                    </div>
                    <div role="button" class="mt-2 font-weight-bold color--blue" *ngIf="isEllipsis" (click)="isEllipsis = false">Read more</div>
                    <div role="button" class="font-weight-bold color--blue" *ngIf="!isEllipsis" (click)="isEllipsis = true">Read  less</div>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "business-entity" -->
            <div class="row my-5 business__entity"
                *ngIf="currentReport?.LATEST?.COMPANY?.NAME && currentReport?.LATEST?.COMPANY?.NAICS">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Business Entity Type</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        This is the type of legal entity the Company is registered as. You can typically find this
                        information on the Company’s federal tax returns, articles of incorporation, and other similar
                        documents.
                    </div>

                    <div class="col-md-12 p-0">
                        <app-custom-select #entityType="ngModel" [(ngModel)]="currentReport.LATEST.COMPANY.ENTITY_TYPE"
                            [values]="entityTypeValues" placeholder="Choose Business Entity Type" name="entityType"
                            id="entityType" (valueSelected)="callUpdateAPI('COMPANY', 'ENTITY_TYPE')" tabindex="6"
                            required [disabled]="currentReport?.isLocked">
                        </app-custom-select>
                    </div>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "franchise" -->
            <div class="row my-5 franchise"
                *ngIf="currentReport?.LATEST?.COMPANY?.NAME && currentReport?.LATEST?.COMPANY?.NAICS && currentReport?.LATEST?.COMPANY?.ENTITY_TYPE">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Is the Company a Franchise?</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>

                    <ng-container>
                        <div class="mb-3 mt-2">
                            <div class="row m-0">
                                <div class="col-12 p-0">
                                    <radio-group-button [selectedOption]="currentReport.LATEST.COMPANY.IS_FRANCHISE"
                                        [btnList]="franchiseOption" [isButton]="true"
                                        [disabled]="currentReport?.isLocked"
                                        radioGroupButtonId="overview-company-franchise-radio-group"
                                        [(ngModel)]="currentReport.LATEST.COMPANY.IS_FRANCHISE" required
                                        id="IS_FRANCHISE" #IS_FRANCHISE="ngModel" name="IS_FRANCHISE"
                                        (optionChange)="currentReport.LATEST.COMPANY.IS_FRANCHISE = $event; callUpdateAPI('COMPANY', 'IS_FRANCHISE')">
                                    </radio-group-button>
                                </div>
                            </div>
                        </div>

                        <ng-container *ngIf="currentReport.LATEST.COMPANY.IS_FRANCHISE">
                            <div class="d-flex align-items-center justify-content-between mt-4">
                                <div class="label">Franchise</div>
                                <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                            </div>

                            <div class="input-group">

                                <div class="col-md-12 search-field p-0">

                                    <app-custom-search-input #FRANCHISE_NAME="ngModel" name="FRANCHISE_NAME" required delay="500"
                                        placeholder="Begin typing franchise name" (outValue)="autocompleteFranchise($event)"
                                        [(ngModel)]="currentReport.LATEST.COMPANY.FRANCHISE_NAME" (focusLost)="franchiseFocusLost()"
                                        [readonly]="currentReport.LATEST.COMPANY.FRANCHISE" (keydown.tab)="franchiseTabPress($event)"
                                        (keydown.arrowup)="franchiseArrowUp($event)" (keydown.arrowdown)="franchiseArrowDown($event)"
                                        (keydown.enter)="pickFranchiseFromList($event)" [tabindex]="8"
                                        (focusGained)="franchiseAutoOpen = true" [disabled]="currentReport?.isLocked"
                                        [hasResults]="franchiseAutoOpen && franchiseList?.length > 0 ? true : false">
                                    </app-custom-search-input>

                                    <a class="lock-icon" id="overview-reset-franchise-name"
                                        *ngIf="currentReport.LATEST.COMPANY.FRANCHISE_NAME"
                                        (click)="currentReport?.isLocked ? '' : resetFranchise()"
                                        (keydown.enter)="resetFranchise()" tabindex="8">
                                        <em class="fa fa-times" aria-hidden="true"></em>
                                    </a>

                                    <div id="FRANCHISE_AUTOCOMPLETE" class="autocomplete custom__scroll input__search"
                                        *ngIf="franchiseList?.length > 0 && franchiseAutoOpen">
                                        <div class="item flex over" *ngFor="let franchise of franchiseList"
                                            (click)="selectFranchise(franchise)" [id]="'FRANCHISE_' + franchise.FRANCHISE_ID"
                                            [ngClass]="{'over': franchise.isOver}"
                                            (keydown.enter)="selectFranchise(franchise)">
                                            {{franchise.FRANCHISE_NAME}}
                                        </div>
                                    </div>

                                    <small
                                        *ngIf="FRANCHISE_NAME.errors && (FRANCHISE_NAME.dirty || FRANCHISE_NAME.touched)"
                                        class="text-danger">required</small>
                                    <small class="text-danger"
                                        *ngIf="currentReport.LATEST.COMPANY.FRANCHISE_NAME && franchiseError && !currentReport.LATEST.COMPANY?.FRANCHISE?.FRANCHISE_ID">Please
                                        enter valid franchise</small>

                                </div>

                                <div class="col-md-12" [hidden]="true">
                                    <input id="overview-latest-company-franchise" type="hidden" #franchise="ngModel"
                                        name="franchise" [(ngModel)]="currentReport.LATEST.COMPANY.FRANCHISE" required>
                                </div>

                            </div>
                        </ng-container>

                    </ng-container>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "business-purpose" -->
            <div class="row my-5 business__purpose"
                *ngIf="currentReport?.LATEST?.COMPANY?.NAME && currentReport?.LATEST?.COMPANY?.NAICS && currentReport?.LATEST?.COMPANY?.ENTITY_TYPE && (currentReport?.LATEST?.COMPANY?.IS_FRANCHISE === true || currentReport?.LATEST?.COMPANY?.IS_FRANCHISE === false)">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">What is the purpose of the business valuation?</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>

                    <div class="col-md-12 p-0">
                        <app-custom-select [disabled]="currentReport?.isLocked"
                            [(ngModel)]="currentReport.LATEST.COMPANY.BUSINESS_PURPOSE" [values]="businessPurposeValues"
                            placeholder="Choose Purpose" name="businessPurpose" id="businessPurpose" #businessPurpose="ngModel" tabindex="9"
                            (valueSelected)="callUpdateAPI('COMPANY', 'BUSINESS_PURPOSE')" required>
                        </app-custom-select>
                    </div>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "transaction-type" -->
            <div class="row my-5" *ngIf="currentReport?.LATEST?.COMPANY?.NAME &&
                    currentReport?.LATEST?.COMPANY?.NAICS && currentReport?.LATEST?.COMPANY?.ENTITY_TYPE &&
                    (currentReport?.LATEST?.COMPANY?.IS_FRANCHISE === true || currentReport?.LATEST?.COMPANY?.IS_FRANCHISE === false) &&
                    (currentReport.LATEST.COMPANY.BUSINESS_PURPOSE == businessPurposeEnum.FINANCIAL_LENDING || currentReport.LATEST.COMPANY.BUSINESS_PURPOSE == businessPurposeEnum.PURCHASE_OR_SALE_BUSINESS)">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Transaction Type</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>
                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                        Please select the type of transaction that best resembles the purpose for this valuation.
                    </div>
                    <ng-container *ngIf="currentReport.LATEST.COMPANY.BUSINESS_PURPOSE == businessPurposeEnum.FINANCIAL_LENDING">
                        <div class="row m-0">
                            <div class="col-md-12 p-0">
                                <radio-group-button [selectedOption]="currentReport.LATEST.COMPANY.TRANSACTION_TYPE"
                                                    [btnList]="transactionListForFinancialLending" [isButton]="true" [disabled]="currentReport?.isLocked"
                                                    radioGroupButtonId="overview-transaction-type-radio-group"
                                                    [(ngModel)]="currentReport.LATEST.COMPANY.TRANSACTION_TYPE" required
                                                    id="TRANSACTION_TYPE" #TRANSACTION_TYPE="ngModel" name="TRANSACTION_TYPE"
                                                    (optionChange)="currentReport.LATEST.COMPANY.TRANSACTION_TYPE = $event; callUpdateAPI('COMPANY', 'TRANSACTION_TYPE')">
                                </radio-group-button>
                            </div>
                        </div>

                        <!--<div class="row mt-3"
                            *ngIf="currentReport.LATEST.COMPANY.TRANSACTION_TYPE == transactionTypeEnum.BUYOUT">
                            <div class="col-md-12 text-warning">
                                <small>
                                    All partner buy-outs for SBA purposes require a third-party valuation from a
                                    <a id="overview-qualified-source-link" href="https://order-dev.reliantvalue.com"
                                        target="_blank" rel="noopener"><u>qualified
                                            source</u></a>.
                                </small>
                            </div>
                        </div>-->
                    </ng-container>
                    <ng-container *ngIf="currentReport.LATEST.COMPANY.BUSINESS_PURPOSE == businessPurposeEnum.PURCHASE_OR_SALE_BUSINESS">
                      <div class="row m-0">
                        <div class="col-md-12 p-0">
                          <radio-group-button [selectedOption]="currentReport.LATEST.COMPANY.TRANSACTION_TYPE"
                                              [btnList]="transactionListForPurchaseOrSaleBusiness" [isButton]="true" [disabled]="currentReport?.isLocked"
                                              radioGroupButtonId="overview-transaction-type-radio-group"
                                              [(ngModel)]="currentReport.LATEST.COMPANY.TRANSACTION_TYPE" required
                                              id="TRANSACTION_TYPE_PURCHASE_OR_SALE_BUSINESS" #TRANSACTION_TYPE="ngModel" name="TRANSACTION_TYPE"
                                              (optionChange)="currentReport.LATEST.COMPANY.TRANSACTION_TYPE = $event; callUpdateAPI('COMPANY', 'TRANSACTION_TYPE')">
                          </radio-group-button>
                        </div>
                      </div>
                    </ng-container>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "other-business-purpose" -->
            <div class="row my-5" *ngIf="currentReport?.LATEST?.COMPANY?.NAME &&
                    currentReport?.LATEST?.COMPANY?.NAICS && currentReport?.LATEST?.COMPANY?.ENTITY_TYPE &&
                    (currentReport?.LATEST?.COMPANY?.IS_FRANCHISE === true || currentReport?.LATEST?.COMPANY?.IS_FRANCHISE === false) &&
                    currentReport.LATEST.COMPANY.BUSINESS_PURPOSE == businessPurposeEnum.OTHER">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">Other Business Purpose</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>
                    <div>
                        <input restrictFirstSpace type="text" class="input input__blue input__large"
                            #OTHER_BUSINESS_PURPOSE="ngModel" name="OTHER_BUSINESS_PURPOSE" id="OTHER_BUSINESS_PURPOSE"
                            [(ngModel)]="currentReport.LATEST.COMPANY.OTHER_BUSINESS_PURPOSE" maxlength="150"
                            tabindex="10" [disabled]="currentReport?.isLocked"
                            (blur)="callUpdateAPI('COMPANY', 'OTHER_BUSINESS_PURPOSE')"
                            (keyup.enter)="callUpdateAPI('COMPANY', 'OTHER_BUSINESS_PURPOSE')" required>
                    </div>
                </div>
            </div>
            <!-- #endregion -->

        </ng-container>

    </form>
</div>
<report-footer [backBtnText]="'Dashboard'" [nextBtnEnable]="overviewForm.valid"
    (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.OVERVIEW"></report-footer>
